import React, { useEffect, useState } from 'react';
import { TWorkingBudget } from '../../types/WorkingBudgetList';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import RadioGroup from '@material-ui/core/RadioGroup';
import { DialogProps } from '@material-ui/core/Dialog';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core/styles';
import { getEstimatesSelectModal } from '../../apicalls/WorkingBudgetList';
import { getLedgerList } from '../../apicalls/ledger';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

type TProps = {
  openSelectModal: boolean;
  setOpenSelectModal: any;
  changeLoggedInData: any;
  setErrorMessage: any;
  setOpen: any;
};

export const SelectModal: React.FC<TProps> = (props: TProps) => {
  const {
    openSelectModal,
    setOpenSelectModal,
    changeLoggedInData,
    setErrorMessage,
    setOpen
  } = props;

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      cancelButton: {
        backgroundColor: '#bdbdbd',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#cccccc',
          boxShadow: 3
        }
      },
      submitButton: {
        backgroundColor: '#007dff',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#2691ff',
          boxShadow: 3
        }
      }
    })
  );

  const classes = useStyles();

  const [fullWidth] = useState(true);
  const [maxWidth] = useState<DialogProps['maxWidth']>('sm');
  const [estimateList, setEstimateList] = useState([]);
  const [selectEstimateId, setSelectEstimateId] = useState<number>();

  useEffect(() => {
    getEstimatesSelectModal().then(data => {
      if (data.data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data.data === 'string') {
          setErrorMessage(data.data);
          setOpen(true);
        } else {
          setEstimateList(data.data);
        }
      }
    });
  }, []);

  return (
    <Dialog
      //maxWidth="xs"
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      open={openSelectModal}
      onClose={() => setOpenSelectModal(false)}
      aria-labelledby='max-width-dialog-title'
    >
      <DialogTitle id='confirmation-dialog-title'>
        帳票を作成する工事を選択してください
      </DialogTitle>
      <DialogContent>
        <TableContainer>
          <Table aria-label='sticky table'>
            <TableHead>
              <TableRow>
                <TableCell
                  style={{ width: '5%', padding: 0 }}
                  align={'center'}
                ></TableCell>
                <TableCell
                  align={'center'}
                  style={{ width: '14%', padding: 0 }}
                >
                  見積書番号
                </TableCell>
                <TableCell
                  style={{ width: '14%', padding: 0 }}
                  align={'center'}
                >
                  工事名
                </TableCell>

                <TableCell
                  style={{ width: '14%', padding: 0 }}
                  align={'center'}
                >
                  案件種別
                </TableCell>
                <TableCell
                  style={{ width: '14%', padding: 0 }}
                  align={'center'}
                >
                  顧客名
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {estimateList &&
                estimateList.length > 0 &&
                estimateList.map((option: any) => (
                  <TableRow key={option.id}>
                    <StyledTableCell
                      align='center'
                      style={{ width: '5%', padding: 0, paddingLeft: 12 }}
                    >
                      <RadioGroup
                        aria-label='Select Customer Name'
                        name='Select Customer Name'
                        value={selectEstimateId}
                        onChange={e =>
                          setSelectEstimateId(Number(e.target.value))
                        }
                      >
                        <FormControlLabel
                          value={option.id}
                          checked={selectEstimateId == Number(option.id)}
                          key={option.id}
                          control={<Radio style={{ color: '#758283' }} />}
                          label={''}
                        />
                      </RadioGroup>
                    </StyledTableCell>
                    <StyledTableCell
                      align={'center'}
                      style={{ width: '10%', padding: 0 }}
                    >
                      {option.id}
                    </StyledTableCell>
                    <StyledTableCell
                      align={'center'}
                      style={{ width: '14%', padding: 0 }}
                    >
                      {option.construct_name}
                    </StyledTableCell>
                    <StyledTableCell
                      align={'center'}
                      style={{ width: '14%', padding: 0 }}
                    >
                      {option.construct_type_name}
                    </StyledTableCell>
                    <StyledTableCell
                      align={'center'}
                      style={{ width: '14%', padding: 0 }}
                    >
                      {option.client_name}
                    </StyledTableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          className={classes.cancelButton}
          onClick={() => setOpenSelectModal(false)}
        >
          キャンセル
        </Button>
        <Button
          className={classes.submitButton}
          disabled={!selectEstimateId}
          variant='contained'
          // 実行予算一覧画面から新規作成を行うモーダル
          // 実行予算追加開発用のため現時点では未使用
          // onClick={() => {
          //   history.push(`/invoices/create`, {
          //     state: constructId,
          //     constructId: constructId,
          //     params: params
          //   });
          // }}
        >
          新規作成
        </Button>
      </DialogActions>
    </Dialog>
  );
};
